import {ScrollingExample, ScrollingFormBottom, ScrollingFormLeft, ScrollingFormRight} from "./ScrollingExample";


export function TitleAniRight(props) {
  const { domRef, formLeftStyle } = ScrollingFormRight();

  return (
    <div
      ref={domRef}
      style={{
        ...formLeftStyle,
        // height: '100%',
      }}
    >
      <h1 className="heading">{props.title} <span>{props.title2}</span></h1>
    </div>
  );
}

export function TitleAniLeft(props) {
  const { domRef, formLeftStyle } = ScrollingFormLeft();

  return (
    <div
      ref={domRef}
      style={{
        ...formLeftStyle,
      }}
    >
      <h1 className="heading">{props.title} <span>{props.title2}</span></h1>
    </div>
  );
}




export function ScrollTest(props) {
  const { domRef, fadeInStyle } = ScrollingExample();

  return (
    <div
      ref={domRef}
      style={{
        ...fadeInStyle,
        height: '100%',
      }}
    >
      {props.title}
    </div>
  );
}

export function ScrollFormLeft(props) {
  const { domRef, formLeftStyle } = ScrollingFormLeft();

  return (
    <div
      ref={domRef}
      style={{
        ...formLeftStyle,
        height: '100%',
      }}
    >
      {props.title}
    </div>
  );
}

export function ScrollFormRight(props) {
  const { domRef, formLeftStyle } = ScrollingFormRight();

  return (
    <div
      ref={domRef}
      style={{
        ...formLeftStyle,
        height: '100%',
      }}
    >
      {props.title}
    </div>
  );
}
export function ScrollFormBottom(props) {
  const { domRefT, formLeftStyleT } = ScrollingFormBottom();

  return (
    <div
      ref={domRefT}
      style={{
        ...formLeftStyleT,
      }}
    >
      {props.title}
    </div>
  );
}